<div fxLayout="column">
  <app-page-header [section]="'Surveys'"
                   [title]="'Explore your surveys'"
                   [description]="'View and manage all surveys and responses for the offering.'">
  </app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column" fxLayoutGap="20px">

    <div fxFlexOffset="20px">
      <div fxLayout="row">
        <span class="subtitle-default">Statistics</span>
      </div>
    </div>

    <div fxLayout="row" fxFlexOffset="30px" fxLayoutGap="20px">

      <div class="info-card pt-3" fxLayout="row" fxLayoutGap="30px">

        <div class="full-width" fxLayout="column" fxLayoutGap="30px" fxFlex="35">

          <div class="full-width px-2" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title-regular">Responses Overview</div>
            <mat-icon>more_vert</mat-icon>
          </div>

          <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px" fxFlexOffset="30px">
            <div class="dashboard-icon">
              <mat-icon class="material-icons-outlined">shopping_bag</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="subtitle-default">Fully completed</div>
              <div class="body-1-default">{{ overviewStats.fullyCompletedApplications }}</div>
            </div>
            <div fxLayout="column" fxLayoutGap="5px">
              <mat-divider></mat-divider>
              <div class="body-1-regular-2">Amount of surveys that were answered in full</div>
            </div>
          </div>

          <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px">
            <div class="dashboard-icon">
              <mat-icon class="material-icons-outlined">store</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="subtitle-default">Partially completed</div>
              <div class="body-1-default">{{ overviewStats.partiallyCompletedApplications }}</div>
            </div>
            <div fxLayout="column" fxLayoutGap="5px">
              <mat-divider></mat-divider>
              <div class="body-1-regular-2">Amount of surveys that were partially completed.</div>
            </div>
          </div>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutAlign="start end" fxFlex="65">
          <app-custom-date-filter [customDateRangePresets]="dateFilters"
                                  [initialPreset]="'this_month'"
                                  (dateRange)="getDateRange($event)"></app-custom-date-filter>

          <div class="full-width" fxFlexOffset="20px" style="height: 350px">
            <canvas  class="dashboard-canvas" baseChart *ngIf="!(loading$ | async); else canvasLoadingSpinner"
                     [data]="overviewStats.chartData"
                     [plugins]="barChartPlugins"
                     [options]="barChartOptions"
                     [type]="'bar'"></canvas>
          </div>

          <ng-template #canvasLoadingSpinner>
            <div fxLayout="row" fxLayoutAlign="center center" style="height: 350px">
              <mat-spinner color="primary" diameter="30"></mat-spinner>
            </div>
          </ng-template>

        </div>

      </div>

    </div>

    <mat-divider fxFlexOffset="30px"></mat-divider>
    <div class="fx-col fx-gap-20">
        <app-crud-table
          [title]="'Surveys'"
          [modelType]="surveyModelType"
          [tableData]="surveys"
          [updatedRow]="updatedSurveyRowData"
          [interruptPendingChanges]="pendingChanges"
          [additionalActions]="surveysAdditionalActions"
          (rowSelected)="surveysRowSelected($event)"
        ></app-crud-table>

        <mat-divider></mat-divider>
    </div>
  </div>

</div>
